import FormSection from '@/components/Forms/FormSection';

import { InstallDocumentTypes, HVACInstallPackageFileCategory } from 'types';

import { DocumentList } from '../Documents/DocumentList';

type LoadCalculationHVACProps = {
  allowArchive?: boolean;
  showCheckboxes: boolean;
  checkboxCategories: HVACInstallPackageFileCategory[];
  isPackageEditable?: boolean;
};

export const LoadCalculationHVAC = ({
  allowArchive,
  showCheckboxes,
  checkboxCategories,
  isPackageEditable = true,
}: LoadCalculationHVACProps) => {
  return (
    <FormSection title="Load Calculation" description={'Upload evidence of the load calculation for this site.'}>
      <DocumentList
        documentTypeFilter={[InstallDocumentTypes.proofOfLoadHVAC]}
        title="Proof of Load Calculation"
        showTypeLabelOnItems={false}
        baseCategory={InstallDocumentTypes.proofOfLoadHVAC}
        allowArchive={allowArchive}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        isPackageEditable={isPackageEditable}
      />
    </FormSection>
  );
};
